import './PreventiveDetailsTools.scss';

import { useDispatch } from "react-redux";

import { usePreventivePdf } from "../../../../../hooks/usePreventivePdf";

import { openDrawer } from "../../../../../slices/drawerSlice";
import { openModal } from "../../../../../slices/modalSlice";

import Subject from "@mui/icons-material/Subject";
import Bookmark from "@mui/icons-material/Bookmark";
import Print from "@mui/icons-material/Print";

import { TextButton } from "../../../../../common-components/Buttons/Buttons";
import { IconButton } from "../../../../../common-components/Buttons/Buttons";

import PreventiveLinksModal from "../../../PreventiveLinksModal/PreventiveLinksModal";
import PreventiveDetailsCard from "../PreventiveDetailsCard/PreventiveDetailsCard";

const PreventiveDetailsTools = ({id}) => {
    const dispatch = useDispatch();

    const { generatePdf } = usePreventivePdf();

    const handleOpen = () => {
        dispatch(openModal({content: <PreventiveLinksModal/>, closeable: true})); 
    }

    const handleOpenCard = () => {
        dispatch(openDrawer({content: <PreventiveDetailsCard id={id}/>, closeable: true}));
    }

    const handlePrint = () => {
        generatePdf();
    }

    return (
        <div className={"preventive-details-tools"}>
            <div className={"preventive-details-tools_container"}>
                <div className={"preventive-details-tools_number"}>

                </div>
                <div className={"preventive-details-tools_desktop-buttons"}>
                    <TextButton Icon={Subject} title={"Подробнее о выезде"} active={true} onClick={handleOpenCard}/>
                    <TextButton Icon={Bookmark} title={"Правила пром.безопасности"} active={true} onClick={handleOpen} color={"#01579b"}/>
                    <TextButton Icon={Print} title={"Печать"} active={true} onClick={handlePrint}/> 
                </div>
                <div className={"preventive-details-tools_mobile-buttons"}>
                    <IconButton Icon={Subject} onClick={handleOpenCard}/>
                    <IconButton Icon={Bookmark} onClick={handleOpen}/>
                </div>
            </div>
        </div>
    )
}

export default PreventiveDetailsTools;